import globals from '@app/globals';
import {settings as api} from '@app/api'
import Constants from '@app/consts'
import string from '@lib/string'
import { country } from '@app/list'

import clsBaseGlobal from './base'

const arrFillable = [
    "url_letter",
    "url_letter_followup",      // Was not set in 
    "id_file_document_letter",
    "letter_show",
    "id_file_document_logo",
    "url_logo",
    "logo_show",
    "logo_margin_left",
    "logo_margin_top",
    "logo_width",
    "company_info_show",
    "company_info_margin_right",
    "company_info_margin_top",
    "font",
    "fontsize",
    "color_custom",
    "color_accent",
    "recipient_margin_left",
    "recipient_margin_top",
    "margin_left",
    "margin_right",
    "margin_top",
    "margin_bottom",
    "content_margin_top",
    "id_theme",
    "letter_type_followup",
    "id_file_document_letter_followup",
    "use_margin_top_followup",
    "margin_top_followup",
    "company",
];


class clsGlobalDocument extends clsBaseGlobal {
    
    get fillable() { return arrFillable; }

    id_file_document_letter          = null;
    url_letter                       = null;
    url_letter_followup              = null;
    letter_show                      = null;
    id_file_document_logo            = null;
    url_logo                         = null;
    logo_show                        = null;
    logo_margin_left                 = null;
    logo_margin_top                  = null;
    logo_width                       = null;
    company_info_show                = null;
    company_info_margin_right   = null;
    company_info_margin_top     = null;
    font                         = null;
    fontsize                         = null;
    color_custom                 = null;
    color_accent                 = null;
    recipient_margin_left            = null;
    recipient_margin_top             = null;
    margin_left                      = null;
    margin_right                     = null;
    margin_top                       = null;
    margin_bottom                    = null;
    content_margin_top               = null;
    id_theme                            = null;

    // Followup letter settings
    letter_type_followup             = "n"; // 'n' = none, 'l' - standard letter, 'f' - followup letter
    id_file_document_letter_followup = null;
    use_margin_top_followup          = false;
    margin_top_followup              = null;

    company                          = [];

    // Helper data
    isLogoUploading                  = false;
    isLetterUploading                = false;
    isFollowupLetterUploading        = false;


    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Deduced and calculated data. See als afterFill().
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    _use_letter_followup = false; // calculated.
    get use_letter_followup() {
        if (!this.letter_show) {
            return false;
        }
        if (!this.url_letter) {
            return false;
        }
        return this._use_letter_followup; 
    }    
    set use_letter_followup(value) {
        if (!value) {
            this._use_letter_followup = false;
            this.letter_type_followup = 'l';
        } else {
            this._use_letter_followup = true;
            this.letter_type_followup = 'n';    // letter by default.
        }
    }


    _use_custom_margins = false;

    get use_custom_margins() { return this._use_custom_margins;}
    set use_custom_margins(v) { 
        if (!v) {
            this.margin_top = 12 
            this.margin_bottom = 12 
            this.margin_left = 12 
            this.margin_right = 12
        }
        this._use_custom_margins = v;
    }

    removeCompanyLine(lineRemove) {
        this.company = this.company.filter( (line) => line != lineRemove);
    }
    addLine(cols) {
        this.company.push( {
            cols : cols?cols:1,
            text1: "",
            text1_style: "",
            text2: "",
            text2_style: "",
            //sequence:
        });
    }
    get resolvedCompanyLines() {
        var fnCountry = function(code) {
            if (!code) { 
                return ""; 
            }
            var result = country.one(code); 
            return result ? (result.name||code) : code;
        }
        var resolve = function(value) {
            if (!value) {
                return value;
            }
            
            value = `${value}`.replaceAll(Constants.document.company.variables.name, globals.company.cpy_name ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.address, string.concat(" ", globals.company.adr_street, globals.company.adr_street_number) ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.zipcity, string.concat(" ", globals.company.adr_zipcode, globals.company.adr_city) ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.country, fnCountry(globals.company.country_code) ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.zipcode, globals.company.adr_zipcode ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.city, globals.company.adr_city ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.phone, globals.company.cpy_phone ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.email, globals.company.cpy_email ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.website, globals.company.cpy_website ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.iban, globals.company.iban1 ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.gaccount, globals.company.ibang ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.kvk, globals.company.cpy_kvk ||"");
            value = `${value}`.replaceAll(Constants.document.company.variables.btw, globals.company.cpy_vatnumber ||"");
            return value;
        }

        return this.company.map(line => ({
            ...line,
            text1: resolve(line.text1),
            text2: resolve(line.text2),
        }));
    }

    async onLogoSelected(files) {
        this.isLogoUploading = true;
        try {
            var result = await api.uploadFileList(files, {
                url: 'upload/document/logo', maxFiles: 1
            })
            
            this.id_file_document_logo = result.data.id;
            this.url_logo = result.data.url;
            this.logo_show = true;
        } 
        finally {
            this.isLogoUploading = false;
        }
        return result;
    }

    async onLetterSelected(files) {
        this.isLetterUploading = true;
        try {
            var result = await api.uploadFileList(files, {
                url: 'upload/document/letter', maxFiles: 1, noCompress: true
            })
            
            this.id_file_document_letter = result.data.id;
            this.url_letter = result.data.url;
            this.letter_show = true;
        } 
        finally {
            this.isLetterUploading = false;
        }
        return result;
    }
    async onFollowupLetterSelected(files) {
        this.isFollowupLetterUploading = true;
        try {
            var result = await api.uploadFileList(files, {
                url: 'upload/document/followupletter', maxFiles: 1, noCompress: true
            })
            
            this.id_file_document_letter_followup = result.data.id;
            this.url_letter_followup = result.data.url;
            this.letter_type_followup = 'f';
        } 
        finally {
            this.isFollowupLetterUploading = false;
        }
        return result;
    }
    toggleStyle(line, n) {
        if (n == 2) {
            line.text2_style = line.text2_style ? "" : "b";
        }
        else {
            line.text1_style = line.text1_style ? "" : "b";
        }
    }


    fill(data) {
        data = data ||{};
        if ( !data.logo_width) {
            data.logo_width = 60;
        }
        data.id_theme                       = data.id_theme || 1;
        
        // Followup page settings
        data.url_letter_followup              = data.url_letter_followup ||"";
        data.letter_type_followup             = data.letter_type_followup || "l";
        data.id_file_document_letter_followup = data.id_file_document_letter_followup
        data.use_margin_top_followup          = !!data.use_margin_top_followup 
        data.margin_top_followup              = data.margin_top_followup || 50;    
        
        return super.fill(data);
    }

    // After filling all the data some of our settings can be deduced from the 
    // loaded data.
    afterFill(data) {
        // Letter followup is enabled when a default letter is selected and the saved setting is not 'same as letter' ('l').
        this._use_letter_followup             = !!this.url_letter && this.letter_show && this.letter_type_followup != 'l'; 

        if (this.margin_top == 12 && this.margin_bottom == 12 && this.margin_left == 12 && this.margin_right == 12) {
            this.use_custom_margins = false;
        } else {
            this.use_custom_margins = true;            
        }
    }
}

export default clsGlobalDocument;